












import Vue from 'vue'
import XeroConnection from '@/components/XeroConnection.vue'
import XeroSync from '@/components/XeroSync.vue'
export default Vue.extend({
    components: { XeroConnection, XeroSync },
    data() {
        return {
            toolbar: {
                title: 'Xero',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back'
                    }
                ],
                right: []
            }
        }
    },
    methods: {
        goToXero(): void {
            window.open(
                'https://go.xero.com/dashboard',
                this.$store.getters.isApp ? '_system' : '_blank'
            )
        }
    }
})
